import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  NgZone,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { DatePickerModule } from 'primeng/datepicker';
import {
  Actions,
  AutomationActionPayload,
  AutomationMaster,
  CampaignActionsGroup,
  CampaignRequest,
  Client,
  CreateRecurringTaskByClientRequest,
  CreateRecurringTaskByOpportunityRequest,
  CreateTaskByClientRequest,
  CreateTaskByOpportunityRequest,
  NotificationToStaff,
  RepeatRuleResponse,
  ReportDataForCampaign,
  Reports,
  STAFFINTERFACE,
  ScheduleActionPayload,
  SourceDataExtractionRules,
  TENANTSINTERFACE,
  TaskActionPayload,
} from '@fitness-force/models';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CampaignSource, OwnershipLevel, Roles, SendNotificationTo, StaffStatus, TaskAssignToType, TaskCreateType, TaskPriority, TaskType } from '@fitness-force/enum';
import { Store } from '@ngrx/store';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputMaskModule } from 'primeng/inputmask';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DividerModule } from 'primeng/divider';
import { ListboxModule } from 'primeng/listbox';

import {
  COMPANY_INFO,
  STAFF_STATE,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';

import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { RruleComponent } from '../../rrule/rrule.component';
import {  MiniSearchComponent,} from '@fitness-force/common/search';
import { TaskCategoryDropdownComponent } from '@fitness-force/crm';

import { PriorityComponent} from '@fitness-force/crm'
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { AuthSevices, CommonService, TaskService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { ErrorsComponent,} from '@fitness-force/common/errors'
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { CampaignService } from 'libs/api/src/lib/campaign/campaign.service';
import { AutomationScheduleTypeComponent } from 'libs/campaigns/src/lib/components/automation-schedule-type/automation-schedule-type.component';
import Statsig from 'statsig-js';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';




@Component({
  selector: 'task-create',
  templateUrl: './task-create.component.html',
  styleUrls: ['./task-create.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    ButtonModule,
    StyleClassModule,
    CommonModule,
    DatePickerModule,
    MultiSelectModule,
    SelectButtonModule,
    InputMaskModule,
    ToggleSwitchModule,
    ScrollPanelModule,
    DividerModule,
    RruleComponent,
    AssignedToComponent,
    MiniSearchComponent,
    ErrorMsgComponent,
    TaskCategoryDropdownComponent,
    PriorityComponent,
    ErrorsComponent,
    AvatarModule,
    ChipModule,
    ListboxModule,
    AutomationScheduleTypeComponent,
    CheckboxModule,
    TranslateModule,
    ToastModule
]
})
export class TaskCreateComponent implements OnInit,OnChanges {
  @Input('visible') showPopup = false;
  @Input('cltIds') clientIds: number[] = [];
  @Input('oppIds') opportunityIds: number[] = [];
  @Input('staffId') assignedToStaffId = 0;
  @Input('clientGroup') clientGroup: any[] = [];
  @Input('opportunity') opportunity: any;
  @Input('clientInfo') clientInfo: any = [];
  @Input('TaskCreateType') taskCreateType: TaskCreateType = TaskCreateType.Single;
  @Input('CampaignSource') CampaignSource : CampaignSource = CampaignSource.Clients;
  @Input('ReportDataForCampaign') ReportDataForCampaign = new BehaviorSubject<ReportDataForCampaign>({} as ReportDataForCampaign); 
  @Input('totalRecords') totalRecords = new BehaviorSubject<number>(0);
  @Input('selectedAllData') selectedAllData = new BehaviorSubject<boolean>(false);
  @Input('actionPayload') actionPayload = new BehaviorSubject<TaskActionPayload>({} as TaskActionPayload); 
  @Input('automationMaster') automationMaster = new BehaviorSubject<AutomationMaster>({} as AutomationMaster);
  @Input('formGroup') taskCreateformGroup: any  = new BehaviorSubject<any>(null);
  @Input('uuid') uuid: string  = "";
  @Input('notificationTo') notificationTo: SendNotificationTo = SendNotificationTo.Client;
  @Input('mode') mode: string  = "create";
  @Input('scheduleInMin') scheduleInMin: number  = 0;
  //@Output('hide') HidePopup: EventEmitter<{closePopup: boolean, data:TaskActionPayload | null}> = new EventEmitter();
  @Output('hide') HidePopup: EventEmitter<{closePopup: boolean, data:any | null, form:UntypedFormGroup | null, uuid:string, notificationTo: SendNotificationTo}> = new EventEmitter();

  @Output('closeTaskPopup') closeTaskPopup: EventEmitter<any> = new EventEmitter();
  @Output('openClientProfile') openClientProfile: EventEmitter<any> = new EventEmitter();

  clientIds$ = new BehaviorSubject<number[]>([]);

  public clients: Client[] = [];
  showMiniSearch = false;
  showRRule = false;
  tenantId = 0;
  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  rRuleObj: RepeatRuleResponse = {} as RepeatRuleResponse;
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  languageCode = '';
  currentUserDetails: any;
  assignedToId = new BehaviorSubject(0);
  showAllMembers = false;
  showCreateProspectPopup$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  selectedTaskcategoryType = new BehaviorSubject<String>('');

  taskTypes:any=[]=[];
  taskTypeOptions:any=[]=[];
  transalteKey: string[] = ['common.TASKTYPE.EMAIL', 'common.TASKTYPE.SMS', 'common.TASKTYPE.CALL', 'common.TASKTYPE.TASK', 'common.TASKTYPE.TOUR'];
  btnLoading=false;


  taskCategoryId:number= 0;
  priority:string="";
  showCampaign = new BehaviorSubject<boolean>(false);
  accessedStaffs:STAFFINTERFACE[] =[];
  showClientSidebar = false;
  activeClientId = 0;
  minimumDate : Date;
  showScheduleType = new BehaviorSubject<boolean>(false);


  constructor(
    public fb: UntypedFormBuilder,
    private store: Store,
    public translate: TranslateService,
    public taskService: TaskService,
    private toastMessageService: ToastMessageService,
    private authService: AuthSevices,
    private ngZone: NgZone,
    public cd:ChangeDetectorRef,
    public timeService:TimeconversionService,
    public campaignService:CampaignService,
    public commonService : CommonService
  )
  {
    this.minimumDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.formGroup = this.fb.group({
      selectedClients: new UntypedFormControl('', [Validators.required]),
      selectedTaskCategory: new UntypedFormControl('', [Validators.required]),
      selectedTask: new UntypedFormControl('', [Validators.required]),
      selectedPriority: new UntypedFormControl('', [Validators.required]),
      selectedAssigned: new UntypedFormControl('', [Validators.required]),
      scheduleDate: new UntypedFormControl(new Date(), [Validators.required]),
      scheduleTime: new UntypedFormControl(new Date(), [Validators.required]),
      title: new UntypedFormControl('', [Validators.required]),
      comment: new UntypedFormControl('', [Validators.required]),
      is_visible: [false, [Validators.required]],
      campaign_name: ['', []],
      campaign_action_date: [new Date(), []],
      campaign_description: ['', []],
      automation_timings_type : [''],
      automation_schedule_type : [''],
      automation_timing : [''],
      notify_record_associated_staff:[''],
      notify_additional_staff_to:[]
    });
    this.taskTypes= [
      { name: 'Call', value: 'call', icon: 'fa fa-phone' },
      { name: 'Tour', value: 'tour', icon: 'fa fa-map-marker-alt' }
  ];

    this.taskTypeOptions= this.taskTypes;
    
    this.setVariables();
  }

  ngOnInit(): void {
    this.setVariables();

    if (Statsig.checkGate('show_campaign'))
    {
      this.showCampaign.next(true);
    }
    
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.languageCode = responseData?.selectedLang?.LANG_CODE;
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
    
    this.store.select(STAFF_STATE).subscribe((staffs: any) => {
      this.accessedStaffs = staffs.staffList.filter((s: STAFFINTERFACE) => 
      (s.role !== Roles.FFAdmin && s.role.toString() !== Roles[Roles.FFAdmin]) &&
      (s.status === StaffStatus.Active || s.status.toString() === StaffStatus[StaffStatus.Active])
    );
    });

    this.currentUserDetails = this.authService.currentUserDetails();
    this.assignedToId.next(this.currentUserDetails.Id);
    if (this.opportunity && this.opportunity?.client_info) {
      this.clientIds$.next([this.opportunity?.client_info.id]);
      this.opportunityIds.push(this.opportunity.id);
      this.clientIds = [];
      this.clientIds.push(this.opportunity?.client_info.id);
    }

    this.translate.get(this.transalteKey).subscribe(translations => {
      this.taskTypes.find((item: { value: string; }) => item.value == 'call').name = translations['common.TASKTYPE.CALL'];
      this.taskTypes.find((item: { value: string; }) => item.value == 'tour').name = translations['common.TASKTYPE.TOUR'];
    });
    this.taskTypeOptions= this.taskTypes;

    this.SelectedTaskCategory.valueChanges.subscribe( o =>{
      if(o?.type && o?.type.toLowerCase() =='operational'){
        this.taskTypeOptions= this.taskTypes.filter((o: { value: string; }) => o.value !='tour');
        this.SelectedTask.setValue(this.taskTypes.find((o: { value: string; }) => o.value =='call'));
      }
      else{
          this.taskTypeOptions= this.taskTypes;
          this.SelectedTask.setValue(null);
      }
      this.cd.detectChanges();
    })
    if(this.taskCreateType == TaskCreateType.Campaign || this.taskCreateType == TaskCreateType.Automation)
    {
      this.formGroup.controls["selectedClients"].removeValidators(Validators.required);
    }

    if(this.taskCreateType == TaskCreateType.Automation)
      this.SelectedAssigned.clearValidators();
    
    if(this.actionPayload && this.actionPayload.value && this.actionPayload.value.category_id > 0)
      this.setInitData()
    else this.showScheduleType.next(true);

    this.valueChangeFunction();
  }

  setInitData()
  {
    if(this.actionPayload.value)
    {
        this.taskCategoryId = this.actionPayload.value.category_id;
        this.priority = this.getEnumStringByNumber(TaskPriority,parseInt(this.actionPayload.value.priority))!;
        this.SelectedAssigned.setValue(this.actionPayload.value.assigned_to_staff_id),
        this.SelectedTask.setValue(  this.taskTypes.find((o: { name: string; }) => o.name == this.getEnumStringByNumber(TaskType,parseInt(this.actionPayload.value.type)))),
        this.Title.setValue(this.actionPayload.value.title),
        this.Comment.setValue(this.actionPayload.value.notes),
        this.ScheduleDate.setValue(this.actionPayload.value.scheduled_date);
        this.ScheduleTime.setValue(this.actionPayload.value.scheduled_date);
    }
    if(this.mode && this.mode =='update')
      {
       let scheduleType = this.scheduleInMin > 0 ? 'After' : this.scheduleInMin < 0 ?  'Before' : 'immidiate';
       let SelectedAutomationTimingType =  this.commonService.formatScheduleTime(this.scheduleInMin,this.automationMaster.value.automation_type.toString());
       this.SelectedAutomationScheduleTypeFormControl.setValue({key:SelectedAutomationTimingType.key,value:SelectedAutomationTimingType.key});
       this.SelectedAutomationTimingTypeFormControl.setValue(scheduleType);
       this.formGroup.controls['automation_timing'].setValue({key:SelectedAutomationTimingType.name,value:SelectedAutomationTimingType.value});
       this.formGroup.updateValueAndValidity();
       this.cd.detectChanges();
      };
      this.showScheduleType.next(true);
  }

  getEnumStringByNumber(enumType: any, value: number) {
    const keys = Object.keys(enumType).filter((key) => enumType[key] === value);
    return keys.length > 0 ? keys[0] : null;
  }

  valueChangeFunction() {
    this.IsVisibleFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        if (value) {
          this.CampaignNameFormControl.setValidators([Validators.required]);
          this.CampaignDescriptionFormControl.setValidators([Validators.required]);
          this.CampaignActionDateFormControl.setValidators([Validators.required]);
        } else {
          this.CampaignNameFormControl.removeValidators([Validators.required]);
          this.CampaignDescriptionFormControl.removeValidators([Validators.required]);
          this.CampaignActionDateFormControl.removeValidators([Validators.required]);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['taskCreateformGroup'] && changes['taskCreateformGroup'].currentValue != null && changes['taskCreateformGroup'].currentValue.value != null && changes['taskCreateformGroup'].currentValue != changes['taskCreateformGroup'].previousValue)
    {
      this.formGroup = changes['taskCreateformGroup'].currentValue.value as UntypedFormGroup;
      this.formGroup.updateValueAndValidity();
    }

    if (changes?.clientIds?.currentValue) {
      this.clientIds = changes?.clientIds?.currentValue;
      this.clientIds$.next([...new Set(this.clientIds)]);
    } else {
      this.clientIds = [];
      this.clientIds$.next([]);
    }

    // if (this.clientInfo && this.clientInfo.length > 0 && changes.clientInfo.currentValue) {
    //   this.clients = changes.clientInfo.currentValue;
    //   this.clientGroup = this.clients;
    //   this.showMiniSearch = true;
    // }
    // if (this.opportunity && changes.opportunity.currentValue) {
    //   this.clientIds = [];
    //   this.opportunityIds.push(this.opportunity.id);
    //   this.clientIds.push(this.opportunity?.client_info.id);
    //   this.opportunityIds.push(this.opportunity?.id);
    //   this.showMiniSearch = false;
    //   this.formGroup.controls.selectedClients.setValue(this.clientIds);
    // }
    // if (this.clientGroup && this.clientGroup?.length > 0 && changes?.clientGroup?.currentValue) {
    //   this.clientIds = [];
    //   this.clientGroup.forEach((val) => {
    //     this.clientIds.push(val.id);
    //   })
    //   this.showMiniSearch = false;
    //   this.formGroup.controls.selectedClients.setValue(this.clientIds);
    // }
  }

  //#region get value
  get SelectedTaskValue(): any {
    let val: any = this.SelectedTask.value;
    let taskType: any;
    if (val && val.value) {
      switch (val.value) {
        case 'email':
          taskType = TaskType.Email;
          break;
        case 'sms':
          taskType = TaskType.Sms;
          break;
        case 'call':
          taskType = TaskType.Call;
          break;
        case 'task':
          taskType = TaskType.Task;
          break;
        case 'tour':
          taskType = TaskType.Tour;
          break;
      }
    }
    return taskType;
  }

  get SelectedPriorityValue(): any {
    let val: any = this.SelectedPriority.value;
    let priority: any;
    if (val && val.value) {
      switch (val.value) {
        case 'high':
          priority = TaskPriority.High;
          break;
        case 'medium':
          priority = TaskPriority.Med;
          break;
        case 'low':
          priority = TaskPriority.low;
          break;
      }
    }
    return priority;
  }

  get SelectedClients(): number[] {
    return this.formGroup.controls.selectedClients.value || [];
  }

  get ScheduledDateTimeValue(): Date {
    let d: Date = this.ScheduleTime.value;
    return new Date(
      this.ScheduleDateValue.getFullYear(),
      this.ScheduleDateValue.getMonth(),
      this.ScheduleDateValue.getDate(),
      d.getHours(),
      d.getMinutes()
    );
  }

  get ScheduleDateValue(): Date {
    let d: Date = this.ScheduleDate.value;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  }

  get ScheduleTimeValue(): string {
    let d: Date = this.ScheduleTime.value;
    return d.getHours() + ':' + d.getMinutes();
  }
  //#region get value

  //#region get
  get SelectedTaskCategory(): UntypedFormControl {
    return this.formGroup.controls.selectedTaskCategory as UntypedFormControl;
  }

  get SelectedTask(): UntypedFormControl {
    return this.formGroup.controls.selectedTask as UntypedFormControl;
  }

  get SelectedPriority(): UntypedFormControl {
    return this.formGroup.controls.selectedPriority as UntypedFormControl;
  }

  get SelectedAssigned(): UntypedFormControl {
    return this.formGroup.controls.selectedAssigned as UntypedFormControl;
  }

  get ScheduleDate(): UntypedFormControl {
    return this.formGroup.controls.scheduleDate as UntypedFormControl;
  }

  get ScheduleTime(): UntypedFormControl {
    return this.formGroup.controls.scheduleTime as UntypedFormControl;
  }

  get Title(): UntypedFormControl {
    return this.formGroup.controls.title as UntypedFormControl;
  }

  get Comment(): UntypedFormControl {
    return this.formGroup.controls.comment as UntypedFormControl;
  }

  get RRuleData(): RepeatRuleResponse {
    return this.rRuleObj || ({} as RepeatRuleResponse);
  }

  get isRruleSet(): boolean {
    return this.rRuleObj && this.rRuleObj.RRule && this.rRuleObj.RRule
      ? true
      : false;
  }


  get CampaignNameFormControl(): UntypedFormControl {
    return this.formGroup.controls['campaign_name'] as UntypedFormControl;
  }

  get CampaignDescriptionFormControl(): UntypedFormControl {
    return this.formGroup.controls['campaign_description'] as UntypedFormControl;
  }

  get CampaignActionDateFormControl(): UntypedFormControl {
    return this.formGroup.controls['campaign_action_date'] as UntypedFormControl;
  }

  //#endregion get

  clearRRuleData() {
    this.rRuleObj = {} as RepeatRuleResponse;
  }

  setClient(e: any) {
    if (Array.isArray(e)) {
      this.clients = e;
    } else if (e && e.clt_id > 0) {
      this.clients = [e];
    } else if (e && e.id) {
      this.clients = [e];
    } else {
      this.clients = [];
    }

    let clientIds: number[] = this.clients.map((c) => {
      return c.clt_id || (c as any)?.id;
    });
    this.formGroup.controls.selectedClients.setValue(clientIds);
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }

  ClosePopUp() {
    this.ngZone.run(() => {
      this.formGroup.reset();
      this.clearRRuleData();
      this.showPopup = false;
     // this.HidePopup.emit({closePopup:false, data:null});
      this.HidePopup.emit({closePopup:false, data:null,form:this.formGroup, uuid:this.uuid, notificationTo: this.notificationTo});
    });
  }

  setVariables(): void {
    this.showMiniSearch = this.clients.length == 0;
    if (this.clientGroup && this.clientGroup.length > 0) {
      this.clientIds = [];
      this.clientGroup.forEach((val) => {
        this.clientIds.push(val.id);
      });
      this.showMiniSearch = false;
      this.formGroup.controls.selectedClients.setValue(this.clientIds);
    }
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    if (this.clientIds && this.clientIds.length > 0) {
      this.formGroup.controls.selectedClients.setValue(this.clientIds);
    }

    if (this.opportunityIds.length > 0 && this.clientIds.length == 0)
      this.clientIds = [0, 0];
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  FetchRRuleData(e: any): void {
    this.rRuleObj = e;
  }


  SaveData()
  {
   
    this.formGroup.markAllAsTouched();
    this.markAllControlsAsDirty(Object.values(this.formGroup.controls));
    if(this.formGroup.valid)
    {
      this.btnLoading=true;
      let obj: TaskActionPayload = {
        assigned_to_type: TaskAssignToType.SpecificStaff,
        assigned_to_staff_id: this.SelectedAssigned.value.id,
        type: this.SelectedTaskValue,
        category_id: this.SelectedTaskCategory.value.id,
        category_name: this.SelectedTaskCategory.value.name_primary_language || this.SelectedTaskCategory.value.name_secondary_language,
        title: this.Title.value,
        notes: this.Comment.value,
        priority: this.SelectedPriorityValue,
        scheduled_date: this.ScheduledDateTimeValue
      };
      if(this.taskCreateType == TaskCreateType.Automation)
      {
        let actions : Actions= {} as Actions;
        let data :ScheduleActionPayload = {
          schedule_in_min: 0,
          actions: actions,
          action_name: "",
          associated_staff: false,
          staff_ids:[],
          description:""
        };
        obj.assigned_to_type = TaskAssignToType.ClientRep;
        obj.assigned_to_staff_id=0;
        data.schedule_in_min= this.SelectedAutomationTimingFormControl.value ? this.SelectedAutomationTimingFormControl.value.value : 0;
        data.action_name = this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.key :  this.SelectedAutomationTimingTypeFormControl.value;
        data.associated_staff = this.SelectedAssociatedStaffFormControl && this.SelectedAssociatedStaffFormControl.value ? this.SelectedAssociatedStaffFormControl.value  : false ;
        data.staff_ids = this.SelectedAdditionalStaffFormControl && this.SelectedAdditionalStaffFormControl.value ? this.SelectedAdditionalStaffFormControl.value.map((staff: any) => staff.id) : [];
        data.actions.email_action_payload = null;
        data.actions.sms_action_payload = null;
        data.actions.whatsapp_action_payload = null;
        data.description = `<strong>${this.SelectedTaskCategory.value.name_primary_language} - </strong> ${this.Title.value}`;
        data.actions.task_action_payload = obj;
        console.log("automation data",data);
        this.showPopup=false;
        this.btnLoading=false;
        this.HidePopup.emit({closePopup:true, data:data,form:this.formGroup, uuid:this.uuid,notificationTo: this.notificationTo});
      }
      else{
        this.showPopup=false;
        this.clearRRuleData();
        this.HidePopup.emit({closePopup:true, data:obj,form:this.formGroup, uuid:this.uuid,notificationTo: this.notificationTo});
      }
      
    }
  }

  CreateTask(): void {
    this.btnLoading=true;
    this.formGroup.markAllAsTouched();
    this.markAllControlsAsDirty(Object.values(this.formGroup.controls));

    if (this.opportunityIds.length > 0 && this.clientIds.length == 0) {
      this.errorMessages.push('client required');
      this.showErrorPopup?.next(true);
      this.btnLoading=false;
      return;
    }

    if(this.taskCreateType == TaskCreateType.Bulk)
    {
       this.SaveCampaign();
    }
    else{
      if (this.rRuleObj && this.rRuleObj.RRule) {
        if (this.opportunityIds.length > 0)
          this.CreateRecurringTaskByOpportunity();
        else this.CreateRecurringTaskByClient();
      } else {
        if (this.opportunityIds.length > 0) this.CreateTaskByOpportunity();
        else this.CreateTaskByClient();
      }
    }

  }

  CreateTaskByClient(): void {
    this.btnLoading=true;
    let obj: CreateTaskByClientRequest = {
      client_id: this.SelectedClients,
      assigned_to_type: TaskAssignToType.SpecificStaff,
      assigned_to_staff_id: this.SelectedAssigned.value.id,
      type: this.SelectedTaskValue,
      category_id: this.SelectedTaskCategory.value.id,
      title: this.Title.value,
      notes: this.Comment.value,
      priority: this.SelectedPriorityValue,
      scheduled_date: this.ScheduledDateTimeValue,
    };
    this.taskService.TaskCreateServiceByClient(this.tenantId, obj).subscribe({
      next: (obj: any) => {
        if (obj.task_id.length > 0) {
          this.translate
            .get('Shared.TASK.TASK-CREATE.TASK_CREATED_MESSAGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
            this.closeTaskPopup.emit({closePopup:true, refreshdata:true})
        } else {
          this.errorMessages.push('Something went wrong');
          this.showErrorPopup?.next(true);
          throw new Error('Error on creating prospect.');
        }
        this.btnLoading=false;
      },
      error: (error: any) => {
        this.btnLoading=false;
        if (error instanceof NotFoundError) {
          this.errorMessages.push(error.originalError.error.errorMessage);
          this.showErrorPopup?.next(true);
        } else {
          if (error.originalError.status == 500) {
            this.errorMessages.push(error.originalError.error);
            this.showErrorPopup?.next(true);
          } else {
            error.originalError.error.forEach((e: any) => {
              this.errorMessages.push(e.errorMessage);
            });
            this.showErrorPopup?.next(true);
          }
        }
      },
    });
  }

  CreateRecurringTaskByClient(): void {
    this.btnLoading=true;
    let obj: CreateRecurringTaskByClientRequest = {
      client_id: this.SelectedClients,
      assigned_to_type: TaskAssignToType.SpecificStaff,
      assigned_to_staff_id: this.SelectedAssigned.value.id,
      type: this.SelectedTaskValue,
      category_id: this.SelectedTaskCategory.value.id,
      title: this.Title.value,
      notes: this.Comment.value,
      priority: this.SelectedPriorityValue,
      start_date: this.ScheduleDateValue,
      time: this.ScheduleTimeValue,
      repeat_rule: this.rRuleObj.RRule,
    };

    this.taskService
      .TaskCreateRecurringServiceByClient(this.tenantId, obj)
      .subscribe({
        next: (obj: any) => {
          if (obj.recurring_template_id.length > 0) {
            this.translate
              .get('Shared.TASK.TASK-CREATE.TASK_CREATED_MESSAGE')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
              this.closeTaskPopup.emit({closePopup:true, refreshdata:true})
          } else {
            this.errorMessages.push('Something went wrong');
            this.showErrorPopup?.next(true);
            throw new Error('Error on creating prospect.');
          }
          this.btnLoading=false;
        },
        error: (error: any) => {
          this.btnLoading=false;
          if (error instanceof NotFoundError) {
            this.errorMessages.push(error.originalError.error.errorMessage);
            this.showErrorPopup?.next(true);
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error);
              this.showErrorPopup?.next(true);
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.showErrorPopup?.next(true);
            }
          }
        },
      });
  }

  CreateTaskByOpportunity(): void {
    this.btnLoading=true;
    let obj: CreateTaskByOpportunityRequest = {
      opportunity_id: this.opportunityIds,
      assigned_to_type: TaskAssignToType.SpecificStaff,
      assigned_to_staff_id: this.SelectedAssigned.value.id,
      type: this.SelectedTaskValue,
      category_id: this.SelectedTaskCategory.value.id,
      title: this.Title.value,
      notes: this.Comment.value,
      priority: this.SelectedPriorityValue,
      scheduled_date: this.ScheduledDateTimeValue,
    };

    this.taskService
      .TaskCreateServiceByOpportunity(this.tenantId, obj)
      .subscribe({
        next: (obj: any) => {
          this.btnLoading=false;
          if (obj.task_id.length > 0) {
            this.translate
              .get('Shared.TASK.TASK-CREATE.TASK_CREATED_MESSAGE')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
              this.closeTaskPopup.emit({closePopup:true, refreshdata:true})
          } else {
            this.errorMessages.push('Something went wrong');
            this.showErrorPopup?.next(true);
            throw new Error('Error on creating prospect.');
          }
        },
        error: (error: any) => {
          this.btnLoading=false;
          if (error instanceof NotFoundError) {
            this.errorMessages.push(error.originalError.error.errorMessage);
            this.showErrorPopup?.next(true);
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error);
              this.showErrorPopup?.next(true);
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.showErrorPopup?.next(true);
            }
          }
        },
      });
  }

  CreateRecurringTaskByOpportunity(): void {
    this.btnLoading=true;
    let obj: CreateRecurringTaskByOpportunityRequest = {
      opportunity_id: this.opportunityIds,
      assigned_to_type: TaskAssignToType.SpecificStaff,
      assigned_to_staff_id: this.SelectedAssigned.value.id,
      type: this.SelectedTaskValue,
      category_id: this.SelectedTaskCategory.value.id,
      title: this.Title.value,
      notes: this.Comment.value,
      priority: this.SelectedPriorityValue,
      start_date: this.ScheduleDateValue,
      time: this.ScheduleTimeValue,
      repeat_rule: this.rRuleObj.RRule,
    };

    this.taskService
      .TaskCreateRecurringServiceByOpportunity(this.tenantId, obj)
      .subscribe({
        next: (obj: any) => {
          if (obj.recurring_template_id.length > 0) {
            this.translate
              .get('Shared.TASK.TASK-CREATE.TASK_CREATED_MESSAGE')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
              this.closeTaskPopup.emit({closePopup:true, refreshdata:true})
          } else {
            this.errorMessages.push('Something went wrong');
            this.showErrorPopup?.next(true);
            throw new Error('Error on creating prospect.');
          }
          this.btnLoading=false;
        },
        error: (error: any) => {
          if (error instanceof NotFoundError) {
            this.errorMessages.push(error.originalError.error.errorMessage);
            this.showErrorPopup?.next(true);
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error);
              this.showErrorPopup?.next(true);
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.showErrorPopup?.next(true);
            }
          }
        },
      });
  }

  SaveCampaign()
  {
      let payloadRequest : CampaignRequest[] = [] as CampaignRequest[];
      let payload : CampaignRequest = {} as CampaignRequest; 
      const formValues = this.formGroup.value;
      payload.campaign_name=formValues["campaign_name"];
      payload.campaign_isvisble=formValues["is_visible"];
      payload.campaign_description=formValues["campaign_description"];
      payload.tenant_id=this.tenantId;
      payload.campaign_ownership = OwnershipLevel.Tenant;
      payload.campaign_franchise = 0;
      payload.actions_group = {} as CampaignActionsGroup;
      let actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
      // actionGroups.campaign_action_date = payload.campaign_isvisble ? this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]) : this.getTomorrowDate();
      actionGroups.campaign_action_date = payload.campaign_isvisble ? this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]) :  new Date().toISOString();
      actionGroups.source_data_type= this.CampaignSource;
      let sourceDataExtractionRules : SourceDataExtractionRules = {} as SourceDataExtractionRules;
      if(this.CampaignSource == CampaignSource.Clients) {
        sourceDataExtractionRules.clients= this.clientIds;
        sourceDataExtractionRules.reports=null;
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;
      }
      else if(this.CampaignSource == CampaignSource.Report) {
        let reports : Reports ={} as Reports;
        let selectedReportData = this.ReportDataForCampaign.value;
        reports.payload = selectedReportData.rpt_fltr_payload;
        reports.relative_date = selectedReportData.rpt_fltr_relative_date_range;
        reports.report_key = selectedReportData.report_key;
        sourceDataExtractionRules.reports = reports;
        sourceDataExtractionRules.clients= null
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;
      }
      else{
        sourceDataExtractionRules.clients=null;
        sourceDataExtractionRules.reports=null;
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;
      }
      actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
      actionGroups.action_payload = [] as AutomationActionPayload[];
      let actionPayloads: AutomationActionPayload = {
        actions: {
          client_email_action_payload: null,
          client_sms_action_payload: null,
          client_whatsapp_action_payload: null,
          staff_email_action_payload: null,
          staff_sms_action_payload: null,
          staff_whatsapp_action_payload: null,
          staff_task_action_payload: null,
          client_pushnotification_action_payload: null,
          staff_pushnotification_action_payload: null,
          notification_staff: null
        },
        schedule_in_min: 0
      };
      actionPayloads.actions.staff_sms_action_payload= null;
      actionPayloads.actions.client_sms_action_payload= null;
      actionPayloads.actions.staff_whatsapp_action_payload= null;
      actionPayloads.actions.client_whatsapp_action_payload= null;
      actionPayloads.actions.staff_email_action_payload= null;
      actionPayloads.actions.client_email_action_payload= null;
      let notificationToStaff : NotificationToStaff ={} as NotificationToStaff;
      notificationToStaff.notify_additional_staff_to = [];
      notificationToStaff.notify_record_associated_staff = true;
      actionPayloads.actions.notification_staff = notificationToStaff;
      let taskActionPayload:TaskActionPayload = {} as TaskActionPayload;
      taskActionPayload.assigned_to_type = TaskAssignToType.SpecificStaff,
      taskActionPayload.assigned_to_staff_id = this.SelectedAssigned.value.id,
      taskActionPayload.type = this.SelectedTaskValue,
      taskActionPayload.category_id = this.SelectedTaskCategory.value.id,
      taskActionPayload.title = this.Title.value,
      taskActionPayload.notes = this.Comment.value,
      taskActionPayload.priority = this.SelectedPriorityValue,
      taskActionPayload.scheduled_date =this.timeService.ConvertLocalDateTimeToUTC(this.ScheduledDateTimeValue),
      taskActionPayload.repeat_rule = this.rRuleObj.RRule,
      actionPayloads.actions.staff_task_action_payload= taskActionPayload;
      actionGroups.action_payload.push(actionPayloads);
      payload.actions_group= actionGroups;
      payloadRequest.push(payload);
      this.campaignService.CreateCampaigns(payloadRequest).subscribe({
        next: (res) => {
          this.translate.get('TASK.TASK-CREATE.TASK_CREATED_MESSAGE')
            .subscribe((translation) => {
             this.toastMessageService.showSuccess(translation);
            });
            this.btnLoading=false;
            this.cd.detectChanges();
            this.ClosePopUp();
        },
        error: (error) => {
          this.toastMessageService.showError(error);
          this.btnLoading=false;
          this.cd.detectChanges();
        },
      });
  }

  getTomorrowDate(): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tomorrowDate = tomorrow.toISOString();
    return tomorrowDate;
  }

  onRemoveClient(index: number) {
    if (this.clientGroup[index]) this.clientGroup.splice(index, 1);
  }

  findInvalidControls() {
    const invalid = [];
    const controls = this.formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public markAllControlsAsDirty(abstractControls: AbstractControl[]): void {
    abstractControls.forEach((abstractControl) => {
      if (abstractControl instanceof UntypedFormControl) {
        (abstractControl as UntypedFormControl).markAsDirty({ onlySelf: true });
      } else if (abstractControl instanceof UntypedFormGroup) {
        this.markAllControlsAsDirty(
          Object.values((abstractControl as UntypedFormGroup).controls)
        );
      } else if (abstractControl instanceof UntypedFormArray) {
        this.markAllControlsAsDirty(
          (abstractControl as UntypedFormArray).controls
        );
      }
    });
  }

  createProspect(event:any){
    this.showCreateProspectPopup$.next(true);
  }

  get IsVisibleFormControl(): UntypedFormControl {
    return this.formGroup.controls['is_visible'] as UntypedFormControl;
  }

  openclientsidebar(event:any)
  {
   this.openClientProfile.emit(event);
  }

  closeSidebar(event:any)
  {
    this.showClientSidebar= false;
    this.openClientProfile.emit(event);
  }

  hidePopup(clientId: number) {
    this.showCreateProspectPopup$.next(false);
  }

  get SelectedAutomationTimingTypeFormControl()
  {
    return this.formGroup.controls['automation_timings_type'] as UntypedFormControl;
  }

  get SelectedAutomationTimingFormControl()
  {
    return this.formGroup.controls['automation_timing'] as UntypedFormControl;
  }

  get SelectedAutomationScheduleTypeFormControl()
  {
    return this.formGroup.controls['automation_schedule_type'] as UntypedFormControl;
  }

  get SelectedAdditionalStaffFormControl()
  {
    return this.formGroup.controls['notify_additional_staff_to'] as UntypedFormControl;
  }

  get SelectedAssociatedStaffFormControl()
  {
    return this.formGroup.controls['notify_record_associated_staff'] as UntypedFormControl;
  }

  public get getTaskCreateType()
  {
    return TaskCreateType;
  }

  public get SendNotificationTo()
  {
    return SendNotificationTo;
  }

}
